module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_yyn-0095ca0946d1236a453b37c0461bcb2d.png";